import debugLib from 'debug';
import dash_api from '../support/dash_api';

import { generateConstants, takeLatest } from '../support/utils';
import { ErrorProvider } from '../../../libraries/branch-tooling-next/Error/ErrorProvider';

const DEBOUNCE_TIME = 230;
const errorProvider = new ErrorProvider();

const debug = debugLib('ScraperAction');
export const FETCH_LINK_INFO = generateConstants('FETCH_LINK_INFO', ['loading']);
export const FETCH_APP_INFO = generateConstants('FETCH_APP_INFO', ['loading']);

export function makeApiCall(uri, isMarketing, dispatch) {
  return dash_api
    .post('/v1/scraper/metadata', { uri })
    .then((payload) => {
      const { data } = payload;
      debug('Data return', data);
      if (data.link_data) {
        data.link_data.$canonical_url = data.link_data.$canonical_url || uri;
      }
      dispatch({ type: FETCH_LINK_INFO.response, data, isMarketing });
    })
    .catch((e) => {
      const error = errorProvider.parse(e).getResponse();
      debug('Error', error);
      dispatch({
        type: FETCH_LINK_INFO.error,
        error,
        uri,
        keepExistingUri: true,
      });
    });
}

const takeLatestFetchLinkDataCall = takeLatest((uri, isMarketing, dispatch) => {
  return makeApiCall(uri, isMarketing, dispatch);
}, DEBOUNCE_TIME);

/**
 * Fetch link data via scraper service
 * @param  {String} uri uri to fetch
 * @return {Object}     link data
 */
export function fetchLinkData({ uri, isMarketing }) {
  return function fetchLink(dispatch) {
    dispatch({ type: FETCH_LINK_INFO.loading, uri });
    return takeLatestFetchLinkDataCall.apply(this, [uri, isMarketing, dispatch]);
  };
}

/**
 * Fetch app data via scraper service
 * @param  {String} uri uri to fetch
 * @return {Object}     link data
 */
export function fetchAppData({ uri }) {
  return function fetchApp(dispatch) {
    if (!uri) {
      return;
    }
    dispatch({ type: FETCH_APP_INFO.loading, uri });
    return dash_api
      .post('/v1/scraper/metadata', { uri })
      .then((payload) => {
        const { data } = payload;
        debug('Data return', data);
        dispatch({ type: FETCH_APP_INFO.response, data });
      })
      .catch((e) => {
        const error = errorProvider.parse(e).getResponse();
        debug('Error', error);
        dispatch({ type: FETCH_APP_INFO.error, error, uri });
      });
  };
}
